export const enableDragToScroll = (container) => {
  if (!container) return;

  let mouseDown = false;
  let startX, scrollLeft;

  const onMouseMove = (event) => {
    if (!mouseDown) return;

    event.preventDefault();

    const x = event.pageX - container.offsetLeft;
    const scroll = x - startX;
    container.scrollLeft = scrollLeft - scroll;
  };

  const onMouseDown = (event) => {
    mouseDown = true;
    startX = event.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  };

  const stopDragging = () => {
    mouseDown = false;
  };

  container.addEventListener("mousedown", onMouseDown);
  container.addEventListener("mousemove", onMouseMove);
  container.addEventListener("mouseup", stopDragging);
  container.addEventListener("mouseleave", stopDragging);
};
